import type { Vaga } from "@/types/vaga";

export type VagaStatus = Vaga["status"];

export interface VagaStatusInfo {
  id: VagaStatus;
  /** Rótulo da coluna do board / do badge. */
  title: string;
  /** Classes do badge (bg/text/border claros). */
  badgeClass: string;
}

/**
 * Fonte ÚNICA das 7 etapas do board de /vagas (status da vaga). Antes esta lista
 * vivia duplicada em Vagas.tsx (colunas do kanban) e em VagaCard.tsx (opções do
 * "mover para"). Reusada também pelo filtro/badge da visão em lista.
 */
export const VAGA_STATUS_COLUMNS: readonly VagaStatusInfo[] = [
  { id: "entrada", title: "Caixa de Entrada", badgeClass: "bg-slate-50 text-slate-700 border-slate-200" },
  { id: "triagem", title: "Triagem", badgeClass: "bg-blue-50 text-blue-700 border-blue-200" },
  { id: "shortlist", title: "Shortlist", badgeClass: "bg-blue-50 text-blue-700 border-blue-200" },
  { id: "checagem_disponibilidade", title: "Checagem de Disponibilidade", badgeClass: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  { id: "validacao", title: "Validação", badgeClass: "bg-purple-50 text-purple-700 border-purple-200" },
  { id: "aprovado", title: "Aprovado", badgeClass: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { id: "reprovado", title: "Reprovado", badgeClass: "bg-red-50 text-red-700 border-red-200" },
] as const;

const STATUS_BY_ID = new Map(VAGA_STATUS_COLUMNS.map((s) => [s.id, s]));

export function getVagaStatusInfo(status: string | null | undefined): VagaStatusInfo | undefined {
  return status ? STATUS_BY_ID.get(status as VagaStatus) : undefined;
}

export function getVagaStatusTitle(status: string | null | undefined): string {
  return getVagaStatusInfo(status)?.title ?? status ?? "—";
}
